export const en = {
    'campaign-group': 'Campaign/group',
    'campaign-type': 'Campaign type',
    'context-price': 'Bid (in ad networks)',
    'context-price-with-currency': 'Bid (in ad networks), {currency}',
    description: 'Note',
    name: 'Name',
    price: 'Maximum CPC',
    status: 'Status',
    targeting: 'Impression criteria'
};
